import store from "@/store";
import { Profile } from "@/store/auth/state";
import { convertRawCallMessage } from "./convertRawCallMessage";
import { convertRawTextMessage } from "./convertRawTextMessage";
import { getIsRawMessageTextType } from "./getIsRawMessageTextType";
import { getIsRawMessageAudioType } from "./getIsRawMessageAudioType";
import { convertRawAudioMessage } from "./convertRawAudioMessage";
import { getIsRawMessageFriendRequestType } from "./getIsRawMessageFriendRequestType";
import { convertRawFriendRequestMessage } from "./convertRawFriendRequestMessage";
import { ConvertRawMessageArgs } from "@/store/chats/types";

export const convertRawMessage = ({
  rawMessage,
  rawChat,
  users,
  ignoreReplies,
}: ConvertRawMessageArgs) => {
  if (!rawMessage) {
    return;
  }
  const authProfile: Profile = store.getters.GET_AUTH_PROFILE;
  const chatId = rawChat.id;
  const commonArgs = {
    rawChat,
    auth: authProfile,
    users,
    ignoreReplies,
  };
  if (getIsRawMessageTextType(rawMessage)) {
    return convertRawTextMessage({ ...commonArgs, rawMessage });
  }
  if (getIsRawMessageAudioType(rawMessage)) {
    return convertRawAudioMessage({ ...commonArgs, rawMessage });
  }

  if (getIsRawMessageFriendRequestType(rawMessage)) {
    return convertRawFriendRequestMessage({ ...commonArgs, rawMessage });
  }

  return convertRawCallMessage(rawMessage, chatId);
};
